var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",attrs:{"id":"menuPage"}},[_c('menu-button',{attrs:{"link":"game","is-primary":""}},[_vm._v("Start Spel")]),_c('menu-button',{attrs:{"link":"settings"}},[_vm._v("Instellingen")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }